<template>
  <div class="project-members-page">
    <BackButton :inert="anyMenusOpen" />
    <div class="page-title">Project View - {{ project.title }}</div>
    <ProjectMembersTable
      :value="project"
      :inertProp="anyMenusOpen"
      @menuEvent="menus.table = $event"
      :class="{ 'table-loading': loadingList }"
      :loading="loadingList"
    />
  </div>
</template>

<script>
import ProjectMembersTable from "./project-members/table.project-members";
import pageMenuEventBubbler from "@/mixins/menu-event-bubblers/meb-page.mixin.js";

export default {
  mixins: [pageMenuEventBubbler],
  components: { ProjectMembersTable },
  head: {
    title: "Payments | Project Team",
    titleTemplate: "%s | iU Community",
  },
  data() {
    return {
      project: {},
      menus: {
        table: false,
      },
      loadingList: false,
    };
  },
  mounted() {
    this.setProject();
  },
  methods: {
    async setProject() {
      this.loadingList = true;
      const { data } = await this.$api.InternalProject.members({
        id: this.$route.params.id,
      });
      this.project = data;
      this.loadingList = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.project-members-page {
  .page-title {
    margin-top: 30px;
    word-wrap: break-word;
  }
}
.table-loading {
  pointer-events: none;
  opacity: 0.5;
}
</style>
